import * as React from 'react'
import { TimeSlotsService } from './timeSlotsService'

export const TimeSlotsServiceContext = React.createContext(null as any as TimeSlotsService)
